<style lang="less">
@import "../../../../styles/public/public.less";
.cz_info {
  height: 100%;
  width: 100%;
  position: relative;
  .info_model {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    margin-bottom: 5px;
    padding-right: 5px;
    .info_model_row {
      height: 40px;
      width: 100%;
      line-height: 40px;
      text-align: center;
      border-top: 1px solid #176095;
      .infoleftborder {
        border-left: 1px solid #176095;
        height: 100%;
        line-height: 40px;
      }
      .inforightborder {
        border-right: 1px solid #176095;
      }
      .infobottomborder {
        border-bottom: 1px solid #176095;
        height: 40px;
        line-height: 40px;
      }
      .info_model_row_t {
        height: 100%;
        width: 100px;
        background: rgba(7, 69, 113, 0.3);
      }
      .info_model_row_c {
        background: rgba(14, 79, 127, 0.8);
        height: 100%;
        width: 120px;
        padding: 0px 10px 0px 10px;
      }
      .ivu-select-dropdown {
        left: -20px !important;
      }
    }
  }
  .btn {
    width: 98%;
    margin-top: 25px;
    .ivu-btn {
      height: 35px;
      width: 150px;
    }
  }
  textarea.ivu-input {
    resize: none;
  }
  .ivu-upload-list-file > span {
    color: #fff;
  }
}
</style>
<template>
  <div class="cz_info display_column">
    <div class="info_model display_wrap_as">
      <Row class="info_model_row">
        <Col span="5" class="infoleftborder">
          <div style="display:flex;justify-content: center;">
            项目名称
            <span class="media_w_w20" style="color:red;margin-top:4px;">&nbsp;*</span>
          </div>
        </Col>
        <Col span="9" class="infoleftborder">
          <Input v-model="dataList.prjname" placeholder="项目名称" :readonly="isread" />
        </Col>
        <Col span="5" class="infoleftborder">项目类别</Col>
        <Col span="5" class="infoleftborder inforightborder">
          <Input v-model="dataList.Typename" readonly />
        </Col>
      </Row>
      <Row class="info_model_row">
        <Col span="5" class="infoleftborder">所属单位</Col>
        <Col span="9" class="infoleftborder">
          <Input v-model="dw.DWMC" readonly />
        </Col>
        <Col span="5" class="infoleftborder">
          <div style="display:flex;justify-content: center;">
            申报年份
            <span class="media_w_w20" style="color:red;margin-top:4px;">&nbsp;*</span>
          </div>
        </Col>
        <Col span="5" class="infoleftborder inforightborder">
          <DatePicker
            type="year"
            v-model="dataList.proYear"
            placeholder="申报年份"
            style="width: 100%;"
            :options="options"
          ></DatePicker>
        </Col>
      </Row>
      <Row class="info_model_row">
        <Col span="5" class="infoleftborder">合作单位</Col>
        <Col span="9" class="infoleftborder">
          <Input v-model="dataList.hzdw" />
        </Col>
        <Col span="5" class="infoleftborder">联系电话</Col>
        <Col span="5" class="infoleftborder inforightborder">
          <Input v-model="dataList.hzdwphone" />
        </Col>
      </Row>
      <Row class="info_model_row" style="height:120px;">
        <Col span="5" class="infoleftborder" style="height:120px;line-height:120px">项目负责人</Col>
        <Col span="4" class="infoleftborder" style="height:120px;">
          <div class="infobottomborder">
            <div style="display:flex;justify-content: center;">
              姓名
              <span class="media_w_w20" style="color:red;margin-top:4px;">&nbsp;*</span>
            </div>
          </div>
          <div class="infobottomborder">
            <div style="display:flex;justify-content: center;">
              学历
              <span class="media_w_w20" style="color:red;margin-top:4px;">&nbsp;*</span>
            </div>
          </div>
          <div class="infobottomborder" style="border:none">
            <div style="display:flex;justify-content: center;">
              联系电话
              <span class="media_w_w20" style="color:red;margin-top:4px;">&nbsp;*</span>
            </div>
          </div>
        </Col>
        <Col span="5" class="infoleftborder" style="height:120px;">
          <div class="infobottomborder">
            <Input v-model="dataList.fzrname" />
          </div>
          <div class="infobottomborder">
            <Input v-model="dataList.fzreducation" />
          </div>
          <div class="infobottomborder" style="border:none">
            <Input v-model="dataList.fzrphone" />
          </div>
        </Col>
        <Col span="5" class="infoleftborder" style="height:120px;">
          <div class="infobottomborder">出生年月</div>
          <div class="infobottomborder">职称</div>
          <div class="infobottomborder" style="border:none">邮箱</div>
        </Col>
        <Col span="5" class="infoleftborder inforightborder" style="height:120px;">
          <div class="infobottomborder">
            <DatePicker type="date" v-model="dataList.fzrbirth" style="width:100%"></DatePicker>
          </div>
          <div class="infobottomborder">
            <Input v-model="dataList.fzrjobtitle" />
          </div>
          <div class="infobottomborder" style="border:none">
            <Input v-model="dataList.fzremail" />
          </div>
        </Col>
      </Row>
      <Row class="info_model_row" style="height:80px;">
        <Col span="5" class="infoleftborder" style="height:80px;line-height:80px;">项目组人数</Col>
        <Col span="4" class="infoleftborder">
          <div class="infobottomborder">
            <div style="display:flex;justify-content: center;">
              高级
              <span class="media_w_w20" style="color:red;margin-top:4px;">&nbsp;*</span>
            </div>
          </div>
          <div>
            <Input v-model="dataList.high_level" placeholder="0" type="number" />
          </div>
        </Col>
        <Col span="5" class="infoleftborder">
          <div class="infobottomborder">
            <div style="display:flex;justify-content: center;">
              中级
              <span class="media_w_w20" style="color:red;margin-top:4px;">&nbsp;*</span>
            </div>
          </div>
          <div>
            <Input v-model="dataList.middle_level" placeholder="0" type="number" />
          </div>
        </Col>
        <Col span="5" class="infoleftborder">
          <div class="infobottomborder">
            <div style="display:flex;justify-content: center;">
              初级
              <span class="media_w_w20" style="color:red;margin-top:4px;">&nbsp;*</span>
            </div>
          </div>
          <div>
            <Input v-model="dataList.junior" placeholder="0" type="number" />
          </div>
        </Col>
        <Col span="5" class="infoleftborder inforightborder">
          <div class="infobottomborder">
            <div style="display:flex;justify-content: center;">
              其他
              <span class="media_w_w20" style="color:red;margin-top:4px;">&nbsp;*</span>
            </div>
          </div>
          <div>
            <Input v-model="dataList.othernum" placeholder="0" type="number" />
          </div>
        </Col>
      </Row>
      <Row class="info_model_row" style="height:80px;">
        <Col span="5" class="infoleftborder" style="height:80px;line-height:20px;padding-top:20px;">
          主要研究内容
          <br />和关键技术
          <span class="media_w_w20" style="color:red;margin-top:4px;">&nbsp;*</span>
        </Col>

        <Col span="19" class="infoleftborder inforightborder" style="height:80px;line-height:80px;">
          <Input v-model="dataList.note" type="textarea" :rows="3" />
        </Col>
      </Row>
      <Row class="info_model_row">
        <Col span="5" class="infoleftborder">开始时间</Col>
        <Col span="9" class="infoleftborder">
          <DatePicker type="date" v-model="dataList.startdate" style="width:100%"></DatePicker>
        </Col>
        <Col span="5" class="infoleftborder">结束时间</Col>
        <Col span="5" class="infoleftborder inforightborder">
          <DatePicker type="date" v-model="dataList.enddate" style="width:100%"></DatePicker>
        </Col>
      </Row>
      <Row class="info_model_row" style="border-bottom:1px solid #176095">
        <Col span="5" class="infoleftborder">
          <div style="display:flex;justify-content: center;">
            总经费
            <span class="media_w_w20" style="color:red;margin-top:4px;">&nbsp;*</span>
          </div>
        </Col>
        <Col span="9" class="infoleftborder">
          <Input
            v-model="dataList.allfunds"
            style="width:81%;margin-right:12px"
            placeholder="0"
            type="number"
          />万元
        </Col>
        <Col span="5" class="infoleftborder">
          <div style="display:flex;justify-content: center;">
            申请园林局拨款
            <span class="media_w_w20" style="color:red;margin-top:4px;">&nbsp;*</span>
          </div>
        </Col>
        <Col span="5" class="infoleftborder inforightborder">
          <Input
            v-model="dataList.yljfunds"
            style="width:65%;margin-right:12px"
            placeholder="0"
            type="number"
          />万元
        </Col>
      </Row>
      <div style="width:100%;">
        <Row class="info_model_row">
          <Col span="5" style="margin-top: 20px;" v-show="!mod_isshow">上传申报书</Col>
          <Col span="9" style="margin-top: 20px;text-align: left;" v-show="!mod_isshow">
            <!-- <Upload
              ref="fileinfo"
              :action="fileAction"
              :before-upload="handleUpload"
              :on-success="successLoad"
              :show-upload-list="false"
            >-->
            <Upload
              multiple
              :action="fileAction"
              :on-error="uplloadError"
              :format="['docx','doc']"
              :on-format-error="handleFormatError"
              :on-success="uplloadSucess"
              ref="fileinfo"
            >
              <Button
                type="info"
                icon="ios-cloud-upload-outline"
                title="申报书上传"
                style="width:150px;"
                @click="updata"
              >上传</Button>
            </Upload>
          </Col>
          <Col span="10" style="float:right;">
            <div class="btn display_row_je dispaly_flex00">
              <Button id="confirmbtn" type="success" @click="click_save()">确认</Button>
              <Button type="error" style="margin-left:20px" @click="click_reset()">重置</Button>
            </div>
          </Col>
        </Row>
        <!-- <div
          v-for="(item,index) in filenick"
          :key="index"
          style="width: 440px;margin-left: 280px;margin-top:30px;"
        >{{item}}</div>-->
      </div>
    </div>
    <Modal
      v-model="model_operate"
      title="上传申报书"
      @on-cancel="modal_operate_cancel"
      :mask-closable="false"
      footer-hide
    >
      <div>
        <div style="margin-top:40px;font-size:18px;display:flex;">
          <div>上传申报书：</div>
          <div>
            <Upload
              multiple
              :action="fileAction"
              :on-error="uplloadError"
              :format="['docx','doc']"
              :on-format-error="handleFormatError"
              :on-success="uplloadSucess"
              ref="fileinfo"
            >
              <Button
                type="info"
                icon="ios-cloud-upload-outline"
                title="申报书上传"
                style="width:150px;"
                @click="updata"
              >上传</Button>
            </Upload>
          </div>
        </div>
        <Row style="margin-top: 25px;">
          <div style="float:right;margin-right:20px;">
            <Button type="error" @click="modal_operate_cancel">取消</Button>
          </div>
        </Row>
      </div>
    </Modal>
  </div>
</template>

<script>
import bus from "../../../../app/event";
export default {
  components: {},
  data() {
    return {
      model_operate: false, //弹窗
      mod_isshow: true,
      filenick: [],
      proid: "",
      fileAction: "",
      isread: false,
      isReSet: true,
      dw: {
        SSDW: this.$store.state.user.SSDW,
        DWMC: this.$store.state.user.DWMC
      },
      newdata: "",
      dataList: {
        proYear: "",
        hzdwphone: "",
        prjname: "",
        Typename: "暂无",
        fzrjobtitle: "",
        othernum: "",
        fzrphone: "",
        startdate: "",
        fzremail: "",
        enddate: "",
        hzdw: "",
        teamnunm: "",
        fzrname: "",
        high_level: "",
        note: "",
        fzrbirth: "",
        middle_level: "",
        allfunds: "",
        fzreducation: "",
        junior: "",
        yljfunds: ""
      },
      options: {
        disabledDate(date) {
          let now = new Date().getFullYear();
          let forbiddate = date.getFullYear();
          return forbiddate <= now - 1;
        }
      }
    };
  },
  methods: {
    //操作关闭
    modal_operate_cancel() {
      this.reset();
      this.guid();
      bus.$emit("to_center");
      this.model_operate = false;
    },
    //重置
    click_reset() {
      if (this.isReSet) {
        //这是新增时重置
        this.reset();
      } else {
        //这是修改时重置
        this.getvalue();
      }
    },
    reset() {
      this.dataList.proYear = "";
      this.dataList.hzdwphone = "";
      this.dataList.prjname = "";
      this.dataList.fzrjobtitle = "";
      this.dataList.othernum = "";
      this.dataList.Typename = "暂无";
      this.dataList.fzrphone = "";
      this.dataList.startdate = "";
      this.dataList.fzremail = "";
      this.dataList.enddate = "";
      this.dataList.hzdw = "";
      this.dataList.fzrname = "";
      this.dataList.high_level = "";
      this.dataList.note = "";
      this.dataList.fzrbirth = "";
      this.dataList.middle_level = "";
      this.dataList.allfunds = "";
      this.dataList.fzreducation = "";
      this.dataList.junior = "";
      this.dataList.yljfunds = "";
      // this.filenick = [];
    },
    //确定(保存)
    click_save() {
      this.$refs.fileinfo.clearFiles(); //清除
      var _this = this;
      //交互，必填项
      if (this.dataList.prjname.length == 0) {
        this.$Message.warning({ content: "请输入项目名称！", duration: 3 });
        return;
      }
      if (this.dataList.proYear == "") {
        this.$Message.warning({ content: "请选择申报年份！", duration: 3 });
        return;
      }
      if (this.dataList.fzrname == "") {
        this.$Message.warning({
          content: "请输入项目负责人姓名！",
          duration: 3
        });
        return;
      }
      if (this.dataList.fzreducation == "") {
        this.$Message.warning({
          content: "请输入项目负责人学历！",
          duration: 3
        });
        return;
      }
      if (this.dataList.fzrphone == "") {
        this.$Message.warning({
          content: "请输入项目负责人联系电话！",
          duration: 3
        });
        return;
      }
      if (this.dataList.high_level == "") {
        this.$Message.warning({
          content: "请输入项目组高级人数！",
          duration: 3
        });
        return;
      }
      if (this.dataList.middle_level == "") {
        this.$Message.warning({
          content: "请输入项目组中级人数！",
          duration: 3
        });
        return;
      }
      if (this.dataList.junior == "") {
        this.$Message.warning({
          content: "请输入项目组初级人数！",
          duration: 3
        });
        return;
      }
      if (this.dataList.othernum == "") {
        this.$Message.warning({
          content: "请输入项目组其他人数！",
          duration: 3
        });
        return;
      }
      if (this.dataList.note == "") {
        this.$Message.warning({
          content: "请输入项目主要研究内容和关键技术！",
          duration: 3
        });
        return;
      }

      if (this.dataList.allfunds == "") {
        this.$Message.warning({ content: "请输入项目总经费！", duration: 3 });
        return;
      }
      if (this.dataList.yljfunds == "") {
        this.$Message.warning({
          content: "请输入申请园林局拨款金额！",
          duration: 3
        });
        return;
      }

      this.dataList.teamnunm =
        parseInt(this.dataList.high_level) +
        parseInt(this.dataList.middle_level) +
        parseInt(this.dataList.junior) +
        parseInt(this.dataList.othernum);

      var _startdate = "";
      if (this.dataList.startdate != "") {
        _startdate = this.formatDateTime(this.dataList.startdate); //开始时间
      }
      var _enddate = "";
      if (this.dataList.enddate != "") {
        _enddate = this.formatDateTime(this.dataList.enddate); //结束时间
      }
      var _fzrbirth = "";
      if (this.dataList.fzrbirth != "") {
        _fzrbirth = this.formatDateTime(this.dataList.fzrbirth); //出生日期
      }
      var _proyear = "";
      if (this.dataList.proYear != "") {
        _proyear = this.formatYear(this.dataList.proYear); //申报年份
      }

      //添加or修改
      if (this.newdata == "") {
        // if (this.fileAction == "") {
        //   this.$Message.warning({
        //     content: "没上传项目申报书",
        //     duration: 3
        //   });
        //   return;
        // }
        //这是添加
        let data = {
          GUID: this.proid, //项目id
          PRJNAME: this.dataList.prjname, //项目名称
          FZRJOBTITLE: this.dataList.fzrjobtitle, //职称
          OTHERNUM: this.dataList.othernum, //其他人数
          PRJTYPE: this.dataList.TYPEID, //项目类别
          FZRPHONE: this.dataList.fzrphone, //联系电话
          STARTDATE: _startdate, //开始时间
          DWID: this.dw.SSDW, //单位编号（所属单位）
          FZREMAIL: this.dataList.fzremail, //邮箱
          ENDDATE: _enddate, //结束时间
          HZDW: this.dataList.hzdw, //合作单位
          TEAMNUNM: this.dataList.teamnunm, //项目组人数
          FZRNAME: this.dataList.fzrname, //负责人名称
          HIGH_LEVEL: this.dataList.high_level, //高级人数
          NOTE: this.dataList.note, //描述
          FZRBIRTH: _fzrbirth, //出生年月
          MIDDLE_LEVEL: this.dataList.middle_level, //中级人数
          ALLFUNDS: this.dataList.allfunds, //总经费
          FZREDUCATION: this.dataList.fzreducation, //学历
          JUNIOR: this.dataList.junior, //初级人数
          YLJFUNDS: this.dataList.yljfunds, //园林局划拨
          USERCODE: this.$store.state.user.USERCODE, //当前登录人的usercode
          AOTHOR_ID: this.$store.state.user.AOTHOR_ID, //当前用户登录的AOTHOR_ID
          ISADMIN: this.$store.state.user.ISADMIN, //当前用户登录的ISADMIN  是否管理员 0：否  1：是
          PROYEAR: _proyear, //申报年份
          HZDWPHONE: this.dataList.hzdwphone //合作单位电话
        };
        this.click_reset();
        this.$http
          .post(
            appurl.ip + "/ylkjservice/services/hander.ashx?action=savepro",
            data
          )
          .then(response => {
            if (response.data.success == true) {
              this.$Message.success({
                content: "保存成功",
                duration: 3
              });

              this.model_operate = true;
              // bus.$emit("save");
              // this.reset();
            } else {
              this.$Message.warning({
                content: "保存失败",
                duration: 3
              });
            }
          })
          .catch(error => {
            this.$Message.warning({
              content: "请求失败",
              duration: 3
            });
          });
      } else {
        let data = {
          ID: this.newdata,
          PRJNAME: this.dataList.prjname, //项目名称
          PRJTYPE: this.dataList.TYPEID, //项目类别
          HZDW: this.dataList.hzdw, //合作单位
          FZRNAME: this.dataList.fzrname, //负责人名称
          FZRBIRTH: _fzrbirth, //出生年月
          FZREDUCATION: this.dataList.fzreducation, //学历
          FZRJOBTITLE: this.dataList.fzrjobtitle, //职称
          FZRPHONE: this.dataList.fzrphone, //联系电话
          FZREMAIL: this.dataList.fzremail, //邮箱
          TEAMNUNM: this.dataList.teamnunm, //项目组人数
          HIGH_LEVEL: this.dataList.high_level, //高级人数
          MIDDLE_LEVEL: this.dataList.middle_level, //中级人数
          JUNIOR: this.dataList.junior, //初级人数
          OTHERNUM: this.dataList.othernum, //其他人数
          STARTDATE: _startdate, //开始时间
          ENDDATE: _enddate, //结束时间
          ALLFUNDS: this.dataList.allfunds, //总经费
          YLJFUNDS: this.dataList.yljfunds, //园林局划拨
          NOTE: this.dataList.note, //描述
          PROYEAR: _proyear, //申报年份
          HZDWPHONE: this.dataList.hzdwphone //合作单位电话
        };
        //这是更新
        this.$http
          .post(
            appurl.ip + "/ylkjservice/services/hander.ashx?action=updatepro",
            data
          )
          .then(response => {
            if (response.data.success == "true") {
              _this.newdata = "";
              _this.isread = false;
              this.$Message.success({
                content: "更新成功",
                duration: 3
              });
              // bus.$emit("save");
              // this.reset();
              bus.$emit("to_center");
            } else {
              this.$Message.warning({
                content: "更新失败",
                duration: 3
              });
            }
          })
          .catch(error => {
            this.$Message.warning({
              content: "请求失败",
              duration: 3
            });
          });
      }
    },
    //界面跳转接收值
    click_state(data, item) {
      this.fileAction = "";
      this.dw.SSDW = this.$store.state.user.SSDW;
      this.dw.DWMC = this.$store.state.user.DWMC;
      var _this = this;
      if (data == "修改") {
        this.mod_isshow = false;
        this.isread = true;
        this.isReSet = false;
        this.getvalue(item);
      } else {
        this.mod_isshow = true;
        this.isread = false;
        this.isReSet = true;
        this.newdata = "";
        this.click_reset();
        this.guid();
      }
    },
    //传过来的值
    getvalue(item) {
      this.newdata = item.ID;
      this.proid = item.ID;
      this.dataList.prjname = item.PRJNAME;
      this.dataList.fzrjobtitle = item.FZRJOBTITLE;
      this.dataList.othernum = item.OTHERNUM;
      if (item.PRJTYPE == 1) {
        this.dataList.Typename = "计划类";
      } else {
        this.dataList.Typename = "指导类";
      }
      this.dataList.fzrphone = item.FZRPHONE;
      this.dataList.startdate = item.STARTDATE;
      this.dataList.fzremail = item.FZREMAIL;
      this.dataList.enddate = item.ENDDATE;
      this.dataList.hzdw = item.HZDW;
      this.dataList.teamnunm = item.TEAMNUNM;
      this.dataList.fzrname = item.FZRNAME;
      this.dataList.high_level = item.HIGH_LEVEL;
      this.dataList.note = item.NOTE;
      this.dataList.fzrbirth = item.FZRBIRTH;
      this.dataList.middle_level = item.MIDDLE_LEVEL;
      this.dataList.allfunds = item.ALLFUNDS;
      this.dataList.fzreducation = item.FZREDUCATION;
      this.dataList.junior = item.JUNIOR;
      this.dataList.yljfunds = item.YLJFUNDS;
      this.dataList.proYear = item.PROYEAR;
      this.dataList.hzdwphone = item.HZDWPHONE;
    },

    //格式化时间，获得YY-MM-DD格式的数据
    formatDateTime(timeStamp) {
      var date = new Date(timeStamp);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
    formatYear(timeStamp) {
      var date = new Date(timeStamp);
      var y = date.getFullYear();
      return y;
    },

    //上传
    updata() {
      // if (this.dataList.prjname == "") {
      //   this.$Message.warning({
      //     content: "上传前，请输入项目名称，且输入后不能修改名称，可上传",
      //     duration: 3
      //   });
      //   return;
      // }

      //上传
      this.fileAction =
        appurl.ip +
        "/ylkjservice/services/hander.ashx?action=uploadcontractfile&PRJNAME=" +
        this.dataList.prjname +
        "&ID=" +
        this.proid;
    },
    //文件上传成功
    uplloadSucess(response, file, fileLists) {
      if (response.success == "true") {
        this.$Message.success({
          content: "文件上传成功",
          duration: 3
        });
      } else {
        this.$Message.success({
          content: "文件上传失败",
          duration: 3
        });
      }
    },
    handleFormatError() {
      this.$Message.error({
        content: "请上传以doc或者docx结尾的文件",
        duration: 3
      });
    },
    uplloadError(error, file, fileLists) {
      this.$Message.error({
        content: "文件上传失败",
        duration: 3
      });
    },
    guid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (this.proid =
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4());
    }
  },
  mounted() {
    bus.$on("center_to", this.click_state);
  },
  beforeDestroy() {
    bus.$off("center_to");
  },
  directives: {}
};
</script>


// WEBPACK FOOTER //
// new_information.vue?ef7bb384